(function () {
  'use strict';
  const footer = document.querySelector('footer.footer');
  if (!footer) return;
  const home = document.createComment('Original site footer position');
  footer.before(home);
  const desktop = window.matchMedia('(min-width: 992px)');
  function syncFooter() {
    const target = desktop.matches && document.querySelector('.jcr-site-footer');
    if (target) {
      if (footer.parentNode !== target) target.appendChild(footer);
    } else if (home.parentNode && footer.previousSibling !== home) {
      home.after(footer);
    }
  }
  // Vue creates/removes the cart dialog. Keep the same footer node and its forms/listeners.
  const observer = new MutationObserver(syncFooter);
  observer.observe(document.body, { childList: true, subtree: true });
  desktop.addEventListener('change', syncFooter);
  syncFooter();
}());
